import type { Control, FieldValues, Path } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { cn } from '@/lib/utils';
import { FIELD_CONTROL_CLASS } from '@/styles/fieldControl';
import { DatePickerInput } from '../DatePickerInput';
import { LabelText } from '../LabelText';
import { FIELD_LABEL_CLASS, FULL_ROW_FIELD_CLASS } from './formDialog.constants';

interface FormDateFieldProps<TValues extends FieldValues> {
  control: Control<TValues>;
  name: Path<TValues>;
  label: string;
  isFullRow?: boolean | undefined;
  isDisabled?: boolean | undefined;
  isOptional?: boolean | undefined;
  isRequired?: boolean | undefined;
}

export function FormDateField<TValues extends FieldValues>({
  control,
  name,
  label,
  isFullRow = false,
  isDisabled = false,
  isOptional = false,
  isRequired = false,
}: FormDateFieldProps<TValues>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className={cn(isFullRow && FULL_ROW_FIELD_CLASS)}>
          <FormLabel className={FIELD_LABEL_CLASS}>
            <LabelText isRequired={isRequired}>{label}</LabelText>
          </FormLabel>
          <FormControl>
            <DatePickerInput
              value={isOptional ? (field.value ?? '') : field.value}
              onChange={(next) => field.onChange(isOptional && next === '' ? undefined : next)}
              className={FIELD_CONTROL_CLASS}
              isDisabled={isDisabled}
              aria-invalid={fieldState.invalid}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
